import customerInstance from './../instance'

const getCustomerCall = (page = 0, size = 0, customerPhone = null) => {
  return customerInstance
    .get('/phones?page=' + page + '&size=' + size + (customerPhone ? '&customerPhone=' + customerPhone : ''))
}

export default getCustomerCall
